import api from './axiosInstance';
import {RawScore, ScoreWithStats} from "../types";
import {getCumulativeWeightedAverage, getCumulativeWeightedMedian, getNormalizedScore} from "../utils/treatmentScore";
import Swal from "sweetalert2";
import {useNavigate} from "react-router";

export const getScores = async (name_category: string) => {
    let scores: RawScore[] = []
    try {
        const response = await api.get('/method/notes.notes.api.score.get_all_scores/'+ name_category)
        scores = response.data.data;
    } catch (error: any) {
        console.error(error);
        return null
    }
    const averages = getCumulativeWeightedAverage(scores);
    const medians = getCumulativeWeightedMedian(scores);

    return scores.map((score, i) => ({
        ...score,
        normalized_score: getNormalizedScore(score),
        cumulativeWeightedAverage: averages[i],
        cumulativeWeightedMedian: medians[i],
    }));
};

export const getScore = async (id: string) => {
    const response = await api.get(`/method/notes.notes.api.score.get_one_score/${id}`);
    return response.data.data;

};

export const createScore = async (score: any) => {
    const response = await api.post('/method/notes.notes.api.score.create_score/', score);
    return response.data.data;
};

export const updateScore = async (id: string, score: any) => {
    const response = await api.put(`/resource/Score/${id}`, score);
    return response.data.data;
};

export const deleteScore = async (id: string) => {
    await api.delete(`/resource/Score/${id}`);
};
